import { Alert, Platform } from 'react-native';

export function alerto(text: string) {
	if (Platform.OS === 'web') {
		return window.alert(text);
	}

	Alert.alert(text);
}

export function confirm(message: string) {
	if (Platform.OS === 'web') {
		return window.confirm(message);
	}

	return new Promise((resolve) => {
		Alert.alert('', message, [
			{ text: 'Yes', onPress: () => resolve(true) },
			{
				text: 'No',
				onPress: () => () => resolve(false),
				style: 'cancel',
			},
		]);
	});
}
